import { TabsList, TabsTrigger } from "@/components/ui/tabs";

export const SETTINGS_TABS = [
  "security",
  "notifications",
  "defaults",
  "billing",
] as const;

export type SettingsTab = (typeof SETTINGS_TABS)[number];

export function SettingsTabsList({
  billingOnly = false,
}: {
  billingOnly?: boolean;
}) {
  return (
    <div className="-mx-4 flex justify-start overflow-x-auto px-4 pb-1 sm:mx-0 sm:justify-center sm:px-0">
      <TabsList className="h-11 shrink-0 p-1">
        <TabsTrigger
          value="security"
          disabled={billingOnly}
          className="cursor-pointer px-3 py-2 text-sm font-medium sm:px-6"
        >
          Security
        </TabsTrigger>
        <TabsTrigger
          value="notifications"
          disabled={billingOnly}
          className="cursor-pointer px-3 py-2 text-sm font-medium sm:px-6"
        >
          Notifications
        </TabsTrigger>
        <TabsTrigger
          value="defaults"
          disabled={billingOnly}
          className="cursor-pointer px-3 py-2 text-sm font-medium sm:px-6"
        >
          Agent Settings
        </TabsTrigger>
        <TabsTrigger
          value="billing"
          className="cursor-pointer px-3 py-2 text-sm font-medium sm:px-6"
        >
          Billing
        </TabsTrigger>
      </TabsList>
    </div>
  );
}
